import { render, staticRenderFns } from "./SettingsFontSize.vue?vue&type=template&id=d74b4958&scoped=true&"
import script from "./SettingsFontSize.vue?vue&type=script&lang=js&"
export * from "./SettingsFontSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74b4958",
  null
  
)

export default component.exports